<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.product") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleCreate()">{{
            $t("new")
          }}</base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
             <div class="row">
 <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>

                <!-- #416 F1: สถานะการใช้งาน — default กำลังใช้งาน, จำใน ?active= -->
                <div class="col-md-2">
                  <el-select
                    v-model="activeFilter"
                    class="wms-active-filter"
                    data-testid="wms-active-filter"
                    :aria-label="$t('wms_product_active.active_filter')"
                    :placeholder="$t('wms_product_active.active_filter')"
                  >
                    <el-option
                      v-for="opt in activeFilterOptions"
                      :key="opt.value"
                      :label="$t(opt.labelKey)"
                      :value="opt.value"
                    ></el-option>
                  </el-select>
                </div>

                <div class="col-md-1">
                 <base-button
                  size="md"
                  type="neutral"
                  @click="ProductExport()"
                >
                  Export
                </base-button>
              </div>
                <div class="col-md-3" v-if="isSpecialUser">
                 <base-button
                  size="md"
                  type="primary"
                  :disabled="recomputingCost"
                  @click.native="RecomputeProductCost()"
                >
                  {{ $t("wms.recompute_cost") }}
                </base-button>
              </div>
             </div>
          </template>
          <div>
            <el-table
              class="bon-table wms-product-table"
              :data="queriedData"
              row-key="ID"
              header-row-class-name="thead-light"
              :row-class-name="rowClassName"
            >
				<el-table-column >
					<div slot-scope="{  row }" class="d-flex">
						<img :src="GetProductUrl(row.Image)" height="100px" v-if="row.Image.includes('.png') || row.Image.includes('.jpg') || row.Image.includes('jpeg')"/>
					</div>
			</el-table-column>

              <!-- #416 F2: ชื่อสินค้า — แถวที่ปิดใช้งาน ชื่อจาง + ป้าย "ปิดใช้งาน" -->
              <el-table-column
                prop="Name"
                :label="$t('wms.product_name')"
                min-width="160"
                sortable
              >
                <template slot-scope="{ row }">
                  <span :class="{ 'text-muted wms-inactive-name': !isRowActive(row) }">{{ row.Name }}</span>
                  <span
                    v-if="!isRowActive(row)"
                    class="badge badge-secondary ml-2 wms-inactive-badge"
                    data-testid="wms-inactive-badge"
                  >{{ $t("wms_product_active.inactive_badge") }}</span>
                </template>
              </el-table-column>

              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <!-- #416 F2: สวิตช์เปิด/ปิดการใช้งาน (สวิตช์แสดงค่าจาก row.is_active เท่านั้น:
                   ยกเลิกใน swal = ไม่มีอะไรเปลี่ยน สวิตช์เด้งกลับเอง) -->
              <el-table-column
                :label="$t('wms_product_active.col_active')"
                width="90"
                align="center"
                class-name="bon-tight"
              >
                <template slot-scope="{ row }">
                  <el-switch
                    :value="isRowActive(row)"
                    :disabled="togglingId === row.ID"
                    data-testid="wms-active-switch"
                    :aria-label="$t('wms_product_active.col_active') + ' ' + row.Name"
                    @change="(v) => onToggleActive(row, v)"
                  ></el-switch>
                </template>
              </el-table-column>

              <!-- #416 F3: เมนู ⋮ แบบ OrdersNew.vue — ตรึงขวา (.bon-table) -->
              <el-table-column
                :label="$t('actions')"
                width="64"
                fixed="right"
                align="center"
                class-name="bon-tight"
              >
                <template slot-scope="{ $index, row }">
                  <el-dropdown trigger="click" placement="bottom-end" @command="(cmd) => onRowCommand(cmd, $index, row)">
                    <base-button
                      size="sm"
                      type="secondary"
                      icon
                      data-testid="row-menu"
                      :aria-label="$t('wms_product_active.menu')"
                      :title="$t('wms_product_active.menu')"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </base-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="a in rowActions"
                        :key="a.key"
                        :command="a.key"
                        :divided="a.divided"
                        :class="{ 'text-danger': a.danger }"
                        :data-testid="'row-action-' + a.key"
                      ><i :class="a.icon" class="mr-2"></i>{{ $t(a.labelKey) }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('wms.product_name')"
          v-model="md.name"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          :label="$t('wms.product_pn')"
          v-model="md.part_number"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          :label="$t('wms.barcode')"
          v-model="md.barcode"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

		<div class="row">
			<div class="col-md-3">
				<base-input :label="$t('wms.width')" v-model="md.width"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.height')" v-model="md.height"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.depth')" v-model="md.depth"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.weight')" v-model="md.weight"/>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<base-input :label="$t('wms.threshold')" v-model="md.threshold"/>
			</div>

		</div>

		<div class="row">
			<!-- A caller who is not on the ต้นทุน allowlist gets a response with
			     NO "Cost" key at all (bo-api #594 §5.4), so md.cost is undefined
			     rather than 0. The field is hidden for them anyway; the guard in
			     handleEdit keeps the undefined from reaching the payload as NaN
			     if the flag and the response ever disagree. -->
			<div class="col-md-6" v-if="isSpecialUser">
				<base-input :label="$t('wms.cost')" v-model="md.cost"/>
			</div>
			<div class="col-md-6">
				<base-input
				:label="$t('wms.partner')"
				input-classes="form-control-alternative new-event--title"
				>
				<el-select v-model="md.partner_id" :placeholder="$t('wms.partner')">
					<el-option
					v-for="option in tablePartner"
					:key="option.ID"
					:label="option.CompanyName"
					:value="option.ID"
					>
					</el-option>
				</el-select>
				</base-input>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<base-input :label="$t('image')" :name="$t('image')" >
					<file-input rules="required" @change="filesChange" ref="fileImage"></file-input>
				</base-input>
			</div>
			<div class="col-md-6">
				<img :src="GetProductUrl(md.image)" height="200px" v-if="md.image.includes('.png') || md.image.includes('.jpg') || md.image.includes('jpeg')"/>
				<img v-if="!md.image.includes('.png') && !md.image.includes('.jpg') && !md.image.includes('jpeg')  && md.image != '' && md.image != null && md.image!= undefined " :src="md.image" height="200px" />
			</div>
		</div>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Switch, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import FileInput from "@/components/Inputs/FileInput";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import wmsProductRefetchOnActivate from "@/mixins/wmsProductRefetchOnActivate";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { read, utils, writeFile } from 'xlsx'
import ReportProvider from "@/resource/report";
import { costReportErrorI18nKey } from "@/utils/costReport";
import { apiErrorMessage } from "@/util/api-error";
import {
  ACTIVE_ON,
  ACTIVE_OFF,
  ACTIVE_ALL,
  HIDE_DELAY_MS,
  activeParam,
  isRowActive,
  toggleConfirmText,
  applyToggleLocally,
  normalizeRows,
  shouldHideAfterToggle,
  toggleToast,
  isBadToggleResponse,
} from "@/utils/wmsProductActive";

const ROUTE_NAME = "WmsProduct";
// #416 F3: the old row buttons, same order; delete last, divided, red.
const ROW_ACTIONS = [
  { key: "barcode", labelKey: "wms.barcode", icon: "fa fa-barcode" },
  { key: "edit", labelKey: "edit", icon: "fa fa-edit" },
  { key: "delete", labelKey: "delete", icon: "fa fa-trash", divided: true, danger: true },
];

const reportService = new ReportProvider();

export default {
  mixins: [clientPaginationMixin, wmsProductRefetchOnActivate],
  components: {
    BasePagination,
    RouteBreadCrumb,
	FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
    getUser : "Auth/getUser",
    isSpecialUser : "Auth/isSpecialUser",
      tablePartner: "WmsPartner/getData",
    }),
    // #416 F1: the page keeps its own rows (any filter); the shared
    // WmsProduct/getData list stays "active only" for every picker.
    activeFilterOptions() {
      return [
        { value: ACTIVE_ON, labelKey: "wms_product_active.active" },
        { value: ACTIVE_OFF, labelKey: "wms_product_active.inactive" },
        { value: ACTIVE_ALL, labelKey: "wms_product_active.active_all" },
      ];
    },
    rowActions() {
      return ROW_ACTIONS;
    },
    tableColumns: function () {

        if (this.isSpecialUser) {
          return [
            {
              prop: "CompanyName",
              label: this.$t("wms.partner"),
              minWidth: 100,
              sortable: true,
            },
            // {
            //   prop: "Amount",
            //   label: this.$t("wms.balance"),
            //   minWidth: 90,
            // },
            {
              prop: "ManPN",
              label: this.$t("wms.product_pn"),
              minWidth: 90,
            },
            {
              prop: "BarCode",
              label: this.$t("wms.barcode"),
              minWidth: 90,
            },
            {
              prop: "Cost",
              label: this.$t("wms.cost"),
              minWidth: 90,
            },
            {
              prop: "Threshold",
              label: this.$t("wms.threshold"),
              minWidth: 90,
            },
            ];
        } else {
      return [
        {
          prop: "CompanyName",
          label: this.$t("wms.partner"),
          minWidth: 100,
          sortable: true,
        },
        {
          prop: "ManPN",
          label: this.$t("wms.product_pn"),
          minWidth: 90,
        },
        {
          prop: "BarCode",
          label: this.$t("wms.barcode"),
          minWidth: 90,
        },
		{
          prop: "Threshold",
          label: this.$t("wms.threshold"),
          minWidth: 90,
        },
      ];
    }
    },
  },
  data() {
    return {
      // #416: rows of the current filter (was the shared WmsProduct/getData)
      tableData: [],
      // F1: from ?active= at creation (data(), so the activeFilter watcher does not
      // fire for it — mounted() does the first load)
      activeFilter: activeParam(this.$route && this.$route.query ? this.$route.query.active : undefined),
      togglingId: null,
      hideTimers: [],
      propsToSearch: ["Name", "BarCode"],
      selectedRows: [],
      // disables the "คำนวณต้นทุน SKU ใหม่" button while the call is in flight
      recomputingCost: false,
      showAddModal: false,
      SearchKeyword: "",
      md: {
        id: 0,
        name: "",
        partner_id: "",
        part_number: "",
        barcode: "",
        width: 0,
        height: 0,
        depth: 0,
        weight: 0,
        cost: 0,
		image:"",
		threshold:0,
      },
      partner: [{ label: "MadameFin", value: 1 }],
    };
  },
  watch: {
    // F1: the select's v-model -> ?active= + reload
    activeFilter(value) {
      this.applyActiveFilter(value);
    },
    // Back / forward or a pasted ?active=: re-read the URL (the activeFilter
    // watcher reloads). A kept-alive instance also sees other pages' routes:
    // ignore those.
    "$route.query.active"(value) {
      if (!this.$route || this.$route.name !== ROUTE_NAME) return;
      const next = activeParam(value);
      if (next !== this.activeFilter) this.activeFilter = next;
    },
  },
  mounted() {
    this.loadRows();
	this.listPartner();
  },
  beforeDestroy() {
    this.hideTimers.forEach((t) => clearTimeout(t));
    this.hideTimers = [];
  },
  methods: {
    ...mapActions({
      createData: "WmsProduct/createData",
      updateData: "WmsProduct/updateData",
      deleteData: "WmsProduct/deleteData",
      listData: "WmsProduct/listData",
      setActive: "WmsProduct/setActive",
      listPartner: "WmsPartner/listData",
      getBarcode: "WmsProduct/getBarcode",

    }),
	isRowActive(row) {
		return isRowActive(row);
	},
	rowClassName({ row }) {
		return isRowActive(row) ? "" : "wms-row-inactive";
	},
	// #416 F1: GET /api/v1/wms/product?active=<filter>
	async loadRows() {
		const filter = this.activeFilter;
		const rows = await this.listData({ active: filter });
		// a newer filter change already started another load
		if (filter !== this.activeFilter) return;
		this.tableData = normalizeRows(rows);
	},
	// #421 F7 (wmsProductRefetchOnActivate): switching back to this kept-alive
	// tab reloads with the CURRENT filter (the mixin default calls listProduct,
	// which this page does not map).
	refetchWmsProducts() {
		return this.loadRows();
	},
	// activeFilter changed (select or URL): keep ?active= in step, reload.
	applyActiveFilter(value) {
		const next = activeParam(value);
		if (next !== value) {
			this.activeFilter = next; // junk -> its watcher comes back here with `next`
			return;
		}
		const query = (this.$route && this.$route.query) || {};
		if (query.active !== next) {
			this.$router.replace({ query: Object.assign({}, query, { active: next }) }).catch(() => {});
		}
		this.loadRows();
	},
	// #416 F3: ⋮ menu
	onRowCommand(cmd, index, row) {
		if (cmd === "barcode") return this.handleBarcode(index, row);
		if (cmd === "edit") return this.handleEdit(index, row);
		if (cmd === "delete") return this.handleDelete(index, row);
	},
	// #416 F2: switch -> swal confirm -> POST once -> row updated in place + toast.
	// `next` = the state the switch asks for; the switch shows row.is_active, so
	// a cancel leaves it where it was.
	async onToggleActive(row, next) {
		if (this.togglingId !== null) return;
		const want = !!next;
		if (want === isRowActive(row)) return;
		const t = (k, p) => this.$t(k, p);
		const msg = toggleConfirmText(t, row, want);
		// titleText: the product name is plain text; html is escaped (stock line, F2)
		const answer = await swal.fire({
			titleText: msg.title,
			html: msg.html,
			icon: "warning",
			showCancelButton: true,
			confirmButtonClass: msg.confirmClass,
			cancelButtonClass: "btn btn-secondary btn-fill",
			confirmButtonText: this.$t("confirm"),
			cancelButtonText: this.$t("cancel"),
			buttonsStyling: false,
		});
		if (!answer || !answer.value) return;
		this.togglingId = row.ID;
		let result;
		try {
			result = await this.setActive({ id: row.ID, is_active: want ? 1 : 0, row });
		} catch (err) {
			// Unexpected 2xx shape (no is_active): generic error + reload, so the
			// table shows whatever the server really holds. The row was never
			// changed, so the switch stays where it was.
			const bad = isBadToggleResponse(err);
			swal.fire({
				title: this.$t("wms_product_active.toggle_failed"),
				text: bad ? this.$t("errors.api.unknown") : apiErrorMessage(err, t),
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false,
			});
			if (bad) this.loadRows();
			return;
		} finally {
			this.togglingId = null;
		}
		const nowActive = result.is_active === 1;
		const set = (o, k, v) => this.$set(o, k, v);
		// the row the switch belongs to, and its copy in the page rows if that is
		// another object (both in place)
		set(row, "is_active", nowActive ? 1 : 0);
		applyToggleLocally(this.tableData, row.ID, nowActive, set);
		const toast = toggleToast(t, nowActive, result.stock_balance);
		this.$notify({ type: toast.type, message: toast.message, verticalAlign: "top", horizontalAlign: "right" });
		if (shouldHideAfterToggle(this.activeFilter, nowActive)) {
			const id = row.ID;
			const timer = setTimeout(() => {
				this.hideTimers = this.hideTimers.filter((x) => x !== timer);
				const current = this.tableData.find((r) => String(r.ID) === String(id));
				// toggled back within the delay, or the filter changed: keep it
				if (!current || !shouldHideAfterToggle(this.activeFilter, isRowActive(current))) return;
				this.tableData = this.tableData.filter((r) => String(r.ID) !== String(id));
			}, HIDE_DELAY_MS);
			this.hideTimers.push(timer);
		}
	},
	// "คำนวณต้นทุน SKU ใหม่" (#265 §7.3). The endpoint is idempotent — pressing
	// it twice must report updated: 0 — so the only thing to guard is a double
	// click while the first call is still running.
	RecomputeProductCost() {
		this.recomputingCost = true;
		reportService
			.ProductCostRecompute({})
			.then((resp) => {
				const body = (resp && resp.data) || {};
				const data = body.Datum || body.Data || {};
				// skipped: true means the API found no cost column to write to,
				// i.e. the migration has not been run. Its counts are all zero,
				// and reporting that as "คำนวณแล้ว 0 SKU · อัปเดต 0" with a green
				// tick reads as "the catalogue is empty" — the one conclusion
				// that stops anyone from running the migration.
				if (data.skipped === true) {
					swal.fire({ title: this.$t("wms.recompute_cost_skipped"), icon: "warning" });
					return;
				}
				swal.fire({
					title: this.$t("wms.recompute_cost_done", {
						scanned: data.scanned || 0,
						updated: data.updated || 0,
						missing: data.missing || 0,
					}),
					icon: "success",
				});
			})
			.catch((err) => {
				// 403 already raised a permission dialog in http.js — replace it
				// only when the API named the reason. Everything else is
				// translated: the raw Msg is a Go constant, not a message.
				const { key, detail } = costReportErrorI18nKey(err);
				const is403 = !!(err && err.response && err.response.status === 403);
				if (is403 && key !== "cost_report.errors.product_cost_forbidden") return;
				swal.fire({ title: this.$t(key), text: detail, icon: "error" });
			})
			.finally(() => {
				this.recomputingCost = false;
			});
	},
	ProductExport() {

        let dataExport = this.tableData.map((item) =>{
			return {
				ID: item.ID,
				Name: item.Name,
				ManPN: item.ManPN,
				BarCode: item.BarCode,
				Cost: item.Cost,
				Threshold: item.Threshold,
			}
		})
		const dataWS = utils.json_to_sheet(dataExport)
		const wb = utils.book_new()
		utils.book_append_sheet(wb, dataWS)
		writeFile(wb,'export_wms_product.xlsx')
    },
    handleCreate() {
      this.showAddModal = true;
      this.md.id = 0;
      this.md.partner_id = this.tablePartner.length > 0 ? this.tablePartner[0].ID : 0;
      this.md.part_number = "";
      this.md.name = "";
      this.md.barcode = "";
      this.md.width = 0;
      this.md.height = 0;
      this.md.depth = 0;
      this.md.weight = 0;
	  this.md.image = "";
	  this.md.threshold = 0;
    },
	handleBarcode(index,row){
		console.log(row)
		this.getBarcode({
          barcode: row.BarCode,
          type: "base64",
        })
          .then((resp) => {
            console.log(resp.data)
			swal.fire({
  title: row.Name,
  html: '<img src="'+resp.data+'">' + row.BarCode,
  showCloseButton: false,
  showCancelButton: false,
  focusConfirm: false,
  confirmButtonText:
    'Close',
  confirmButtonAriaLabel: 'Thumbs up, great!',

})
          })
          .catch((err) => {
            swal.fire({
              title: "สร้าง Barcode ผิดพลาด",
              text: "Barcode : " + row.BarCode,
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });

	},
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.id = row.ID;
      this.md.partner_id = row.PartnerID;
      this.md.part_number = row.ManPN;
      this.md.name = row.Name;
      this.md.barcode = row.BarCode;
      this.md.width = row.SizeWidth;
      this.md.height = row.SizeHeight;
      this.md.depth = row.SizeDepth;
      this.md.weight = row.Weight;
      // row.Cost is ABSENT (not 0) for a caller outside the allowlist.
      this.md.cost = row.Cost === undefined || row.Cost === null ? 0 : row.Cost;
	  this.md.image = row.Image == null ? "": row.Image;
	  this.md.threshold = row.Threshold
	  this.$refs.fileImage.clearFile()
	},
    handleUpdate() {
      this.showAddModal = false;

      if (this.md.id == 0) {
        // create
        this.createData({
          Name: this.md.name,
          ManPN: this.md.part_number,
          PartnerID: this.md.partner_id,
          SizeHeight: parseInt(this.md.height),
          SizeDepth: parseInt(this.md.depth),
          SizeWidth: parseInt(this.md.width),
          Weight: parseInt(this.md.weight),
          BarCode: this.md.barcode,
          Cost: isNaN(parseFloat(this.md.cost)) ? 0 : parseFloat(this.md.cost),
		  Image : this.md.image,
		  Threshold: parseInt(this.md.threshold)
        })
          .then((resp) => {
            this.loadRows();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      } else {
        // update

        this.updateData( {
          id: this.md.id,
		  payload : {
          Name: this.md.name,
          ManPN: this.md.part_number,
          PartnerID: this.md.partner_id,
          SizeHeight: parseInt(this.md.height),
          SizeDepth: parseInt(this.md.depth),
          SizeWidth: parseInt(this.md.width),
          Weight: parseInt(this.md.weight),
          BarCode: this.md.barcode,
          Cost: isNaN(parseFloat(this.md.cost)) ? 0 : parseFloat(this.md.cost),
		  Image : this.fileNameIsImage(this.md.image) ? "": this.md.image ,
		  Threshold: parseInt(this.md.threshold)
		  }
        })
          .then((resp) => {
            this.loadRows();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteData(row.ID)
              .then((resp) => {
                this.loadRows();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              })
              .catch((err) => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false,
                });
              });
          }
        });
    },
	filesChange(files) {
		if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
			swal.fire({
				title: "Error",
				text: "กรุณาเลือกไฟล์รูปภาพ",
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false
			});

			this.$refs.fileImage.clearFile();
			return;
		}


		if (files[0].size > 1024 * 1024 *2) {
			swal.fire({
				title: "Error",
				text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false
			});
			this.$refs.fileImage.clearFile();
			return;
		}

		const reader = new FileReader();
		reader.readAsDataURL(files[0]);
		reader.onload = () => {
			this.md.image = reader.result;
		};
	},

	GetProductUrl(filename){
		console.log("FileName " + filename)
		return process.env.VUE_APP_API_BASE_URL + "/files/wms_products/" + filename
	},
	fileNameIsImage(filename) {
		return filename.includes(".png") || filename.includes(".jpg") || filename.includes(".jpeg")
	}
},
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
<style scoped>
/* #416 F1: the filter select fills its column like the search input */
.wms-active-filter {
  width: 100%;
}
/* #416 F2: a disabled product's name is clearly dimmer (the badge carries the meaning) */
.wms-inactive-name {
  opacity: 0.6;
}
</style>
